import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios'

import { joinURL } from '@/app/utils'

type MakeSafeRequestOptions = {
  okIfStatus?: number | number[]
}

export class HttpService {
  axios: AxiosInstance
  endpoint: string

  constructor(endpoint: string) {
    this.axios = axios
    this.endpoint = endpoint
  }

  protected getPath(...input: string[]) {
    return joinURL([
      process.env.NEXT_PUBLIC_API_HOST ?? '',
      this.endpoint,
      ...input.map(x => x.toString())
    ])
  }

  async makeSafeRequest<TResponse>(
    axiosConfig: AxiosRequestConfig,
    { okIfStatus = 200 }: MakeSafeRequestOptions = {}
  ) {
    let ok = false
    try {
      const { status, data, headers } =
        await this.axios.request<TResponse>(axiosConfig)

      if (Number.isInteger(okIfStatus)) {
        ok = okIfStatus === status
      } else if (Array.isArray(okIfStatus)) {
        ok = okIfStatus.includes(status)
      }

      return { ok, data, headers, errors: null }
    } catch (error) {
      return {
        ok,
        ...(error instanceof AxiosError && {
          errors: error.response,
          headers: error.response?.headers
        })
      }
    }
  }
}
